import _ from 'lodash';
import GeoRule from './rules/GeoRule';
import DayRule from './rules/DayRule';
import TimeRule from './rules/TimeRule';
import StepUpRule from './rules/StepUpRule';
import NewToGPMexStoreRule from './rules/NewToGPMexStoreRule';
import AtaRule from './rules/AtaRule';
import SegpRule from './rules/SegpRule';
import { getDefaultOperator, getRuleType } from './utils';

const SECONDS_SINCE_MIDNIGHT: string[] = ['var.ride.pickupTime.secondsSinceMidnight', 'var.app.time.secondsSinceMidnight', 'var.ride.completeTime.secondsSinceMidnight', 'var.ride.confirmTime.secondsSinceMidnight', 'var.event.time.secondsSinceMidnight', 'var.currentTime.secondsSinceMidnight', 'timeOfDay'];
const DAY_OF_WEEK: string[] = ['var.ride.pickupTime.dayOfWeek', 'var.app.time.dayOfWeek', 'var.ride.completeTime.dayOfWeek', 'var.ride.confirmTime.dayOfWeek', 'var.event.time.dayOfWeek', 'var.currentTime.dayOfWeek', 'dayOfWeek'];
const GEO_RULES: string[] = ['var.ride.pickupLocation', 'var.ride.dropoffLocation', 'var.app.location'];
const GEOFENCE: string = 'var.geofence.';
const STEP_UP: string = 'var.custom.stepUp.ridesSince';
const NEW_TO_GP_MEX: string = 'var.custom.payment.newToMex';
const NEW_TO_GP_STORE: string = 'var.custom.payment.newToStore';
const ATA_RULE: string = 'var.ride.arrival.timeSpan';
const SEGP_RULES: string[] = ['var.merchant.segment', 'var.user.segments', 'var.merchant.chainNumber.segment', 'var.passenger.segment', 'var.driver.segment', 'var.pax.digibank.segment', 'var.merchantGrabID.segment', 'var.familyHost.segment'];
const DEFAULT_TIME_RANGE: number[] = [0, 86399];

type RuleCondition = {
  operator: string;
  lhs: string;
  rhs: any;
};

type RuleConfig = {
  operator: string;
  conditions: RuleCondition[];
};

type CustomRenderers = {
  [key: string]: any;
};

type CustomInsert = {
  [key: string]: (ruleTypes: any) => RuleConfig;
};

type RuleBuilderConfig = {
  geofenceVariable: string;
  customError: {
    [key: string]: string;
  };
  customRenderers: CustomRenderers;
  customInsert: CustomInsert;
  hiddenRuleTypes: string[];
};

type GetRuleBuilderConfigParams = {
  countryIDKey?: string;
  useSegpWidget?: boolean;
};

const getSecondsSinceMidnightConfig = (ruleTypes: any, index: number): RuleConfig => {
  return {
    operator: 'and',
    conditions: [
      {
        operator: getDefaultOperator(getRuleType(ruleTypes, SECONDS_SINCE_MIDNIGHT[index])),
        lhs: SECONDS_SINCE_MIDNIGHT[index],
        rhs: DEFAULT_TIME_RANGE,
      },
      {
        operator: getDefaultOperator(getRuleType(ruleTypes, DAY_OF_WEEK[index])),
        lhs: DAY_OF_WEEK[index],
        rhs: [],
      },
    ],
  };
};

const getCustomRenderers = (countryIDKey: string, useSegpWidget: boolean): CustomRenderers => {
  const customRenderers: CustomRenderers = {
    [ATA_RULE]: AtaRule,
    [GEOFENCE]: [
      GeoRule,
      (state: any) => {
        return {
          countryID: _.get(state, countryIDKey),
        };
      },
    ],
    [STEP_UP]: StepUpRule,
    [NEW_TO_GP_MEX]: NewToGPMexStoreRule,
    [NEW_TO_GP_STORE]: NewToGPMexStoreRule,
  };
  if (useSegpWidget) {
    SEGP_RULES.forEach((key) => customRenderers[key] = SegpRule);
  }
  DAY_OF_WEEK.forEach((key) => customRenderers[key] = DayRule);
  SECONDS_SINCE_MIDNIGHT.forEach((key) => customRenderers[key] = TimeRule);
  GEO_RULES.forEach((key) => customRenderers[key] = [
    GeoRule,
    (state: any) => {
      return {
        countryID: _.get(state, countryIDKey),
      };
    },
  ]);
  return customRenderers;
};

const getCustomInsert = (): CustomInsert => {
  const customInsert: CustomInsert = {};
  SECONDS_SINCE_MIDNIGHT.forEach((key) => customInsert[key] = (ruleTypes: any) => getSecondsSinceMidnightConfig(ruleTypes, 0));
  return customInsert;
};

const getRuleBuilderConfig = ({ countryIDKey = '', useSegpWidget = false }: GetRuleBuilderConfigParams): RuleBuilderConfig => ({
  geofenceVariable: GEOFENCE,
  customError: {
    [STEP_UP]: 'Try reducing the number of TaxiTypes',
  },
  customRenderers: getCustomRenderers(countryIDKey, useSegpWidget),
  customInsert: getCustomInsert(),
  hiddenRuleTypes: [...DAY_OF_WEEK, 'var.ride.pickupTime.unix'],
});

export default getRuleBuilderConfig;
